import { render, staticRenderFns } from "./sysTicketItem.vue?vue&type=template&id=3e3368c6&"
import script from "./sysTicketItem.vue?vue&type=script&lang=js&"
export * from "./sysTicketItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports